import { Badge } from '@/components/ui/Badge'
import { Text } from '@/components/ui/Text'

export interface ChecklistItem {
  label: string
  state: 'READY' | 'NEEDED' | 'BLOCKED'
}

interface Day0ReadinessChecklistProps {
  items: ChecklistItem[]
}

const STATE_BADGE: Record<
  ChecklistItem['state'],
  { variant: 'success' | 'warning' | 'outline'; label: string; ariaLabel?: string }
> = {
  READY: { variant: 'success', label: 'Ready' },
  NEEDED: { variant: 'warning', label: 'Start' },
  BLOCKED: { variant: 'outline', label: 'Locked', ariaLabel: 'Locked — not yet available' },
}

export function Day0ReadinessChecklist({ items }: Day0ReadinessChecklistProps) {
  return (
    <ul role="list" className="flex flex-col divide-y divide-border">
      {items.map((item, i) => {
        const badge = STATE_BADGE[item.state]
        return (
          <li key={i} className="flex items-center justify-between gap-3 py-3">
            <Text variant="body-sm">{item.label}</Text>
            <Badge
              variant={badge.variant}
              aria-label={badge.ariaLabel ?? badge.label}
            >
              {badge.label}
            </Badge>
          </li>
        )
      })}
    </ul>
  )
}
